import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom'; // Import hooks
import PropTypes from 'prop-types';
import { parse } from 'query-string';
import has from 'lodash/has';
import ConfiguratorWrapper from './ConfiguratorWrapper';
import Breadcrumbs from '../components/Breadcrumbs';
import './App.css';
import { BreadCrumbContainer } from './styles';
import { SET_IS_FROM_SAVE } from '../actions/actionCreators';
import { updatePath } from '../actions/pathActions';
import { updateConfigProductId } from '../actions';

function App({
  afterRulesExecuted,
  appMount,
  onConfiguratorLoaded,
  onSaveConfiguration,
  partnerProductId,
  isInitialized,
  isLoading
}) {
  const dispatch = useDispatch();
  const location = useLocation();
  const params = parse(location.search);
  const { omsId } = params;
  const isFromEdit = has(params, 'isEdit');
  const isFromSave = !!params.save;

  const partnerProductIdExpandedSkus = 619182;
  const productId = omsId ? partnerProductIdExpandedSkus : partnerProductId;
  dispatch(updateConfigProductId(productId));

  useEffect(() => {
    const { item: itemId } = params;
    appMount(productId, itemId, isFromSave);
  }, []);

  useEffect(() => {
    dispatch({ type: SET_IS_FROM_SAVE, });
  }, [isFromSave]);

  return (
    <>
      <div className="app-container">
        <div className="breadcrumb-container" data-testid="breadcrumbs">
          <Breadcrumbs />
        </div>
        <ConfiguratorWrapper
          afterRulesExecuted={afterRulesExecuted}
          isFromEdit={isFromEdit}
          isFromSave={isFromSave}
          onChoiceSelectedSuccess={() => dispatch(updatePath())}
          onConfiguratorLoadSuccess={onConfiguratorLoaded}
          onSaveConfiguration={onSaveConfiguration}
          productId={productId}
          omsId={omsId}
          isInitialized={isInitialized}
          isLoading={isLoading}
        />
      </div>
    </>
  );
}

App.propTypes = {
  afterRulesExecuted: PropTypes.func.isRequired,
  appMount: PropTypes.func.isRequired,
  onConfiguratorLoaded: PropTypes.func.isRequired,
  onSaveConfiguration: PropTypes.func.isRequired,
  partnerProductId: PropTypes.number.isRequired,
  isInitialized: PropTypes.number.isRequired,
  isLoading: PropTypes.number.isRequired,
};

export default App;
